import React, { useState, useEffect } from 'react';
import SMTPService from '../../services/SMTPService';
import Swal from 'sweetalert2';

const SMTPConfigList = () => {
  const [smtpConfig, setSMTPConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    smtp_host: '',
    smtp_port: '',
    smtp_username: '',
    smtp_password: '',
    smtp_secure: '',
    sender_email: '',
    sender_name: '',
  });

  useEffect(() => {
    fetchSMTPConfig();
  }, []);

  const fetchSMTPConfig = async () => {
    setLoading(true);
    try {
      const data = await SMTPService.get();
      setSMTPConfig(data);
      setFormData({
        smtp_host: data.smtp_host || '',
        smtp_port: data.smtp_port || '',
        smtp_username: data.smtp_username || '',
        smtp_password: data.smtp_password || '',
        smtp_secure: data.smtp_secure || '',
        sender_email: data.sender_email || '',
        sender_name: data.sender_name || '',
      });
    } catch (error) {
      Swal.fire('Error', 'Failed to fetch SMTP configuration', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      if (smtpConfig) {
        await SMTPService.update(formData);
        Swal.fire('Updated', 'SMTP configuration updated successfully', 'success');
      } else {
        await SMTPService.create(formData);
        Swal.fire('Created', 'SMTP configuration created successfully', 'success');
      }
      fetchSMTPConfig();
    } catch (error) {
      Swal.fire('Error', 'Failed to save SMTP configuration', 'error');
    }
  };

  const handleDelete = async () => {
    try {
      await SMTPService.delete(smtpConfig.id);
      Swal.fire('Deleted', 'SMTP configuration deleted successfully', 'success');
      setSMTPConfig(null);
      setFormData({
        smtp_host: '',
        smtp_port: '',
        smtp_username: '',
        smtp_password: '',
        smtp_secure: '',
        sender_email: '',
        sender_name: '',
      });
    } catch (error) {
      Swal.fire('Error', 'Failed to delete SMTP configuration', 'error');
    }
  };

  if (loading) {
    return <p>Loading...</p>;
  }

  return (
    <div className="content-wrapper">
      <div className="row">
        <div className="col-md-8 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">SMTP Configuration</h4>
              <form onSubmit={handleSave}>
                <div className="form-group">
                  <label>SMTP Host</label>
                  <input
                    type="text"
                    className="form-control"
                    name="smtp_host"
                    value={formData.smtp_host}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>SMTP Port</label>
                  <input
                    type="number"
                    className="form-control"
                    name="smtp_port"
                    value={formData.smtp_port}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>SMTP Username</label>
                  <input
                    type="text"
                    className="form-control"
                    name="smtp_username"
                    value={formData.smtp_username}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>SMTP Password</label>
                  <input
                    type="password"
                    className="form-control"
                    name="smtp_password"
                    value={formData.smtp_password}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>SMTP Secure</label>
                  <select
                    className="form-control"
                    name="smtp_secure"
                    value={formData.smtp_secure}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="ssl">SSL</option>
                    <option value="tls">TLS</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Sender Email</label>
                  <input
                    type="email"
                    className="form-control"
                    name="sender_email"
                    value={formData.sender_email}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Sender Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="sender_name"
                    value={formData.sender_name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <button type="submit" className="btn btn-primary mr-2">
                  Save
                </button>
                {smtpConfig && (
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={handleDelete}
                  >
                    Delete
                  </button>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SMTPConfigList;
